import { Client } from '../types/Client';
import { BuilderType, projectsCacheTags } from './projectsApiHelpers';

export type CustomerChannelOptionStatus = 'available' | 'unmaterialized' | 'blocked';

export type CustomerChannelOption = {
  type: string;
  label: string;
  status: CustomerChannelOptionStatus;
  node_id?: number;
};

export type CustomerChannelPlacementRequest = {
  target_parent_id: number;
  channel_type: string;
  dealer_id?: number;
  customer: Partial<Client>;
};

export type CustomerChannelPlacementResponse = {
  customer: Client;
  placement: CustomerChannelOption;
};

export const customerChannelPlacementsApi = (builder: BuilderType) => ({
  getCustomerChannelOptions: builder.query<CustomerChannelOption[], number>({
    query: (targetParentId) => ({
      url: `service/customer-channel-options`,
      params: { target_parent_id: targetParentId },
    }),
    providesTags: [projectsCacheTags.CHANNEL_TYPES],
  }),

  createCustomerChannelPlacement: builder.mutation<
    CustomerChannelPlacementResponse,
    CustomerChannelPlacementRequest
  >({
    query: (body) => ({
      url: `service/customer-channel-placements`,
      method: 'POST',
      body,
    }),
    invalidatesTags: [projectsCacheTags.CHANNEL_TYPES, projectsCacheTags.CLIENTS],
  }),
});
